import React from "react";
import { Navbar } from "reactstrap";
import "./PanduNav.css";
import SubNav3 from "./SubNav3";
import { NavLink, MDBBtn } from "mdbreact";
import { Link } from "react-router-dom";
import { Typography, Grid, Button, Container } from "@material-ui/core";
import Header1 from "./Header";
import { Layout, Divider } from "antd";
import { MailOutlined, PhoneOutlined } from "@ant-design/icons";
const { Header } = Layout;
export default class PanduNav extends React.Component {
  state = {
    sticky: false,
    headerHidden: false,
  };

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const isSticky = window.scrollY > 150;
    this.setState({
      sticky: isSticky,
      headerHidden: isSticky,
    });
  };

  render() {
    return (
      <>
        {/* <Header1 /> */}

        {/* MAIN HEADER */}
        {/* <Layout className="main-header-class">
          <Header className="main-header-header" style={{ padding: 0 }}> */}
          <Layout>
  {/* TOP UTILITY BAR */}
  <div
    style={{
      background: "linear-gradient(90deg, #0A1F44 0%, #14306b 100%)",
      color: "#ffffff",
      fontSize: 13,
      fontWeight: 500,
      letterSpacing: 0.2,
    }}
  >
    <Container maxWidth="xl">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          padding: "8px 20px",
          minHeight: 38,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 24,
            flexWrap: "wrap",
          }}
        >
          <span style={{ display: "inline-flex", alignItems: "center" }}>
            <PhoneOutlined style={{ marginRight: 6, color: "#7eb6ff" }} />
            0361 - 3515332 (O)
          </span>
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              opacity: 0.4,
            }}
          >
            |
          </span>
          <span style={{ display: "inline-flex", alignItems: "center" }}>
            <MailOutlined style={{ marginRight: 6, color: "#7eb6ff" }} />
            dispurcollege1978@gmail.com
          </span>
        </div>
        <div
          style={{
            fontSize: 12,
            fontWeight: 600,
            letterSpacing: 0.6,
            textTransform: "uppercase",
            color: "#cfd8e8",
          }}
        >
          Internship & Apprenticeship Cell
        </div>
      </div>
    </Container>
  </div>

  {/* MAIN HEADER */}
  <Header
    style={{
      padding: 0,
      background: "#ffffff",
      height: "auto",
      lineHeight: "normal",
      borderBottom: "1px solid #e6e9ef",
      boxShadow: "0 2px 8px rgba(10, 31, 68, 0.04)",
    }}
  >
    <Container maxWidth="xl">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 24,
          padding: "18px 20px",
          flexWrap: "wrap",
        }}
      >
        {/* LEFT : LOGO + COLLEGE NAME */}
        <Link
          to="/"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 16,
            color: "#0A1F44",
            textDecoration: "none",
          }}
        >
          <img
            src="/images/logo-dispurcollege.png"
            alt="Dispur College Logo"
            style={{
              width: 84,
              height: 84,
              objectFit: "contain",
              display: "block",
            }}
          />

          <div
            style={{
              lineHeight: 1.2,
              borderLeft: "3px solid #2962ff",
              paddingLeft: 14,
            }}
          >
            <div
              style={{
                fontSize: 11,
                fontWeight: 600,
                letterSpacing: 1.4,
                textTransform: "uppercase",
                color: "#2962ff",
                marginBottom: 4,
              }}
            >
              Dispur College, Guwahati
            </div>
            <div
              style={{
                fontSize: 22,
                fontWeight: 700,
                color: "#0A1F44",
                margin: 0,
                lineHeight: 1.15,
              }}
            >
              Internship & Apprenticeship Cell
            </div>
            
          </div>
        </Link>

        {/* RIGHT : NAAC */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            padding: "8px 14px",
            border: "1px solid #e6e9ef",
            borderRadius: 8,
            backgroundColor: "#f8fafc",
          }}
        >
          <img
            src="/images/naac.webp"
            alt="NAAC"
            style={{
              width: 70,
              height: 70,
              objectFit: "contain",
              display: "block",
            }}
          />
          <div style={{ maxWidth: 180, lineHeight: 1.3 }}>
            <div
              style={{
                fontSize: 10,
                fontWeight: 600,
                letterSpacing: 1.2,
                textTransform: "uppercase",
                color: "#5a6374",
                marginBottom: 2,
              }}
            >
              Accredited by
            </div>
            <div
              style={{
                fontSize: 14,
                fontWeight: 700,
                color: "#0A1F44",
              }}
            >
              NAAC &mdash; Grade A
            </div>
            <div
              style={{
                fontSize: 11,
                fontWeight: 500,
                color: "#5a6374",
              }}
            >
              3rd Cycle Accreditation
            </div>
          </div>
        </div>
      </div>
    </Container>
  </Header>
</Layout>



        {/* SUB NAV */}
        <div style={{ backgroundColor: "#D6DBDF" }}>
          <SubNav3
            width="200px"
            color="#1E3760"
            backgroundOfNav="white"
            backgroundColor="#D6DBDF"
            textColor="white"
            history={this.props.history}
          />
        </div>
      </>
    );
  }
}


// export default class PanduNav extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       sticky: false,
//       headerHidden: false,
//     };
//   }

//   componentDidMount() {
//     window.addEventListener("scroll", this.handleScroll);
//   }

//   componentWillUnmount() {
//     window.removeEventListener("scroll", this.handleScroll);
//   }


//   handleScroll = () => {
//     if (window.scrollY < 150) {
//       this.setState({
//         sticky: false,
//         headerHidden: false,
//       });
//     } else if (window.scrollY > 150) {
//       this.setState({
//         sticky: true,
//         headerHidden: true,
//       });
//     }
//   };

//   render() {
//     return (
//       <div>
//         <Header1 />
//         <Layout className="main-header-class">
//           <Header
            
//             className="main-header-header"
//           >
//             <Container>
//               <div
//                 style={{
//                   backgroundColor: "#ED7D31",
//                   display: "flex",
//                   flexDirection: "row",
//                   alignItems: "center",
//                 }}
//               >
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={12} md={12} lg={12}>
//                     <div
//                       className="main-logo-text-div"
//                     >
//                       <a href="/">
//                         <img
//                           className="logo-img"
//                           src={"/images/nss.png"}
//                           alt="logo"
//                         />
//                       </a>
//                       <div style={{
//                         lineHeight: 1,
//                         fontFamily: "Gothic A1",
//                         fontSize: 12,
//                         fontWeight: 700,
//                         display: "flex",
//                         flexDirection: "column",
//                         justifyContent: "center",
//                         alignItems: "center",
//                       }}>
//                       <div style={{ display: "flex", alignItems: "center", color: "white" }}>
//                         <PhoneOutlined style={{ fontSize: 16 }} /> &nbsp;
//                         80115-76322(O)
//                       </div>
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           marginTop: 4,
//                           color: "white"
//                         }}
//                       >
//                         <MailOutlined style={{ fontSize: 16, color: "white" }} /> &nbsp;
//                         principal.eraligool@gmail.com
//                       </div>
//                       </div>
//                       <div className="naac-div-text">
//                         <img src={`/images/b-plus-bg.png`}  style={{width: 100}}/>
//                         <div className="naac-div-text-text">Accredited by NAAC with B+ Grade in 1st cycle</div>
//                       </div>
//                     </div>
//                   </Grid>

//                   <Grid item xs={12} sm={12} md={12} lg={12}>
//                     <div
//                       style={{
//                         lineHeight: 1.2,
//                         fontFamily: "Gothic A1",
//                         fontSize: 14,
//                         fontWeight: 700,
//                         display: "flex",
//                         justifyContent: "center",
//                         alignItems: "center",
//                       }}
//                     >
                      
//                     </div>
//                     <div></div>
//                   </Grid> 
//                 </Grid>  
//               </div>
//             </Container>
//           </Header>
//         </Layout>

//         <div style={{ backgroundColor: "#D6DBDF" }}>
//           <SubNav3
//             // sticky={this.state.sticky}
//             width={`200px`}
//             color={`#1E3760`}
//             backgroundOfNav={`white`}
//             backgroundColor={`#D6DBDF`}
//             textColor={`white`}
//             history={this.props.history}
//           />
//         </div>

       
//       </div>
//     );
//   }
// }
 {/* for mobile */}
        {/* <div className="m-display">
          <Navbar expand="md" className="main-nav-class m-display">
            <a href="/">
              <img
                className="logo-img"
                src={
                  "/images/tnclogo.png"
                }
                alt="logo"
              />
            </a>
            <div
              className="navbar-div-text"
              style={{
                flexBasis: "auto",
                margin: "15px",
                padding: "0 10px",
              }}
            >
              <Typography className="nav-bar-div-text-h" variant="h1">
                {this.props.data != undefined ? <span>{this.props.data.dept_name_as}</span> : 'THONG NOKBE COLLEGE'}
              </Typography>
              <Typography className="nav-bar-div-text-h" variant="h4">
                {this.props.data != undefined ? <span>{this.props.data.dept_name}</span> : <img src="/images/tnctext.png" style={{ width: '6em' }} alt="" />}
              </Typography>
            </div>
          </Navbar>
        </div> */}